import { render, staticRenderFns } from "./VisibleInvisibleFrame.vue?vue&type=template&id=528a803a&scoped=true&"
import script from "./VisibleInvisibleFrame.vue?vue&type=script&lang=ts&"
export * from "./VisibleInvisibleFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528a803a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VLayout,VSwitch})
